import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';

import useProject from 'hooks/useProject';
import { hyperparameterState, isProjectChangeState, shouldUpdateCodeState, takeSnapshotState } from 'state/atoms';

const useProjectMount = () => {
  const setHyperparameter = useSetRecoilState(hyperparameterState);
  const setIsProjectChange = useSetRecoilState(isProjectChangeState);
  const setShouldUpdateCode = useSetRecoilState(shouldUpdateCodeState);
  const setTakeSnapshot = useSetRecoilState(takeSnapshotState);

  const project = useProject({ refetchOnMount: 'always' });

  useEffect(() => {
    const hyperparameter = project.data?.hyperparameter;
    if (hyperparameter) {
      setHyperparameter(hyperparameter);
    }
  }, [project, setHyperparameter]);

  useEffect(() => {
    setIsProjectChange(false);
    setShouldUpdateCode(false);
    setTakeSnapshot((prev) => ({
      ...prev,
      projectChange: () => setIsProjectChange(true),
      updateCode: () => setShouldUpdateCode(true),
    }));
  }, [setIsProjectChange, setShouldUpdateCode, setTakeSnapshot]);

  return project;
};

export default useProjectMount;
